import { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import { DownIcon } from "../../../icons";

export const SortDropdown = ({
  disabled,
  onChange,
  state,
}) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(state?.stepThree);
  const ref = useRef(null);

  // close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const options = [
    { label: "Διαθεσιμότητα", value: "FirstAvailableAvis" },
    { label: "Απόσταση", value: "NearestAvis" },
  ];

  const selectedLabel =
    options.find(o => o.value === value)?.label;

  const handleSelect = (newValue) => {
    setValue(newValue);
    setOpen(false);
    onChange?.(newValue); // ενημέρωσε parent αν χρειάζεται
  };

  return (
    <div ref={ref} className="relative inline-block">
      <button
        disabled={disabled}
        onClick={() => setOpen(prev => !prev)}
        className={clsx(
          "flex flex-row gap-2 items-center rounded-xl py-3 pl-6 pr-4 text-sm font-semibold border",
          disabled
            ? "bg-fadedgrey text-white cursor-not-allowed"
            : "border-fadedgrey bg-white"
        )}
      >
        {selectedLabel}
        <DownIcon
          width={24}
          height={24}
          className={clsx(
            "transition-transform",
            open && "rotate-180"
          )}
        />
      </button>

      {open && !disabled && (
        <div className="absolute z-50 mt-2 w-full bg-white rounded-xl shadow-md">
          {options.map(opt => (
            <button
              key={opt.value}
              onClick={() =>{ handleSelect(opt.value) }}
              className={clsx(
                "w-full text-left px-4 py-3 text-sm hover:bg-powdergrey",
                value === opt.value && "font-semibold"
              )}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};